import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function WindowsIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 28 32" {...props}>
      <path d="M25.0347 0.00339611C24.8093 -0.00710389 24.5817 0.00665305 24.3542 0.0459308L14 1.85062V14.0004H28V3.11147C28 2.19058 27.5957 1.32219 26.8911 0.729525C26.3626 0.285025 25.7111 0.0348961 25.0347 0.00339611ZM10.8889 2.39142L2.57639 3.84064C1.08461 4.10197 0 5.39106 0 6.90617V14.0004H10.8889V2.39142ZM0 17.1115V24.2057C0 25.7208 1.08461 27.0099 2.57639 27.2712L10.8889 28.7204V17.1115H0ZM14 17.1115V29.2612L24.3542 31.0659C24.5331 31.097 24.713 31.1115 24.8919 31.1115C25.6184 31.1115 26.3248 30.8553 26.8911 30.3793C27.5957 29.7866 28 28.9197 28 28.0004V17.1115H14Z" />
    </SvgIcon>
  );
}
